module.exports = "../../../../platform/assets/pageMainIcon/icon-renyuan-4-green.svg";